import { withContext } from 'components/withContext';
import { createContext } from 'react';

const NumberContext = createContext();
const NumberConsumer = withContext(NumberContext, 'number');

export { NumberContext, NumberConsumer };
